import { useState } from 'react';
import { Sheet, SheetContent } from './ui/sheet';
import { Wand2, Layers as LayersIcon } from 'lucide-react';

/**
 * Bottom navigation that opens drawer-sheets containing the same
 * ToolPanel / LayersPanel content as the desktop sidebars.
 *
 * Receives the panel children as props so this component stays layout-only.
 */
export const MobileBottomBar = ({ toolsPanel, layersPanel, layerCount }) => {
  const [open, setOpen] = useState(null); // null | 'tools' | 'layers'

  return (
    <>
      <nav
        data-testid="mobile-bottom-bar"
        className="lg:hidden h-16 bg-paper border-t-2 border-ink flex items-stretch z-30 pr-[140px]"
      >
        <button
          data-testid="mobile-tools-btn"
          onClick={() => setOpen('tools')}
          className="flex-1 flex flex-col items-center justify-center gap-0.5 active:bg-lilac/40 transition-colors border-r-2 border-ink"
        >
          <Wand2 className="h-5 w-5" strokeWidth={2.5} />
          <span className="font-outfit text-[10px] font-bold uppercase tracking-widest">Tools</span>
        </button>
        <button
          data-testid="mobile-layers-btn"
          onClick={() => setOpen('layers')}
          className="flex-1 flex flex-col items-center justify-center gap-0.5 active:bg-mint/40 transition-colors relative"
        >
          <LayersIcon className="h-5 w-5" strokeWidth={2.5} />
          <span className="font-outfit text-[10px] font-bold uppercase tracking-widest">Layers</span>
          {layerCount > 0 && (
            <span className="absolute top-2 right-[28%] min-w-[18px] h-[18px] px-1 border-2 border-ink bg-sun font-mono text-[10px] font-bold flex items-center justify-center rounded-sm">
              {layerCount}
            </span>
          )}
        </button>
      </nav>

      <Sheet open={open === 'tools'} onOpenChange={(v) => !v && setOpen(null)}>
        <SheetContent
          side="bottom"
          data-testid="mobile-tools-sheet"
          className="bg-paper border-t-2 border-ink rounded-t-sm p-0 h-[80vh] max-h-[80vh] overflow-hidden"
        >
          <div className="h-full overflow-y-auto tidy-scroll">
            {toolsPanel}
          </div>
        </SheetContent>
      </Sheet>

      <Sheet open={open === 'layers'} onOpenChange={(v) => !v && setOpen(null)}>
        <SheetContent
          side="bottom"
          data-testid="mobile-layers-sheet"
          className="bg-paper border-t-2 border-ink rounded-t-sm p-0 h-[70vh] max-h-[70vh] overflow-hidden"
        >
          <div className="h-full overflow-y-auto tidy-scroll">
            {layersPanel}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
